
export type LayerModelLayerType = typeof LayerModelLayerType[keyof typeof LayerModelLayerType];


export const LayerModelLayerType = {
  DECOR: 'DECOR',
  SYMBOL: 'SYMBOL',
  COVERAREA: 'COVERAREA',
  BRACKETPOSITION: 'BRACKETPOSITION',
  CLAMPPOSITION: 'CLAMPPOSITION',
  CLAMPRANGE: 'CLAMPRANGE',
  CROSSPOSITION: 'CROSSPOSITION',
  PLUMBINGSTRUTRANGE: 'PLUMBINGSTRUTRANGE',
  PLUMBINGSTRUTPOSITIONL: 'PLUMBINGSTRUTPOSITIONL',
  PLUMBINGSTRUTPOSITIONR: 'PLUMBINGSTRUTPOSITIONR',
  TIERODPOSITION: 'TIERODPOSITION',
  TIERODPOSITION1: 'TIERODPOSITION1',
  TIERODPOSITION2: 'TIERODPOSITION2',
  BOLTPOSITION: 'BOLTPOSITION',
  PINPOSITION: 'PINPOSITION',
  TOPPLATFORMRANGE: 'TOPPLATFORMRANGE',
  UNICLAMPPOSITION: 'UNICLAMPPOSITION',
  UNIVERSALPOSITION: 'UNIVERSALPOSITION',
  WALLINGRANGE: 'WALLINGRANGE',
  TABLEBEAM: 'TABLEBEAM',
  LACBLU: 'LACBLU',
  LACGRE: 'LACGRE',
  PLABLU: 'PLABLU',
  PLYBRO: 'PLYBRO',
  SHEBRO: 'SHEBRO',
  SHEGRE: 'SHEGRE',
  SHEYEL: 'SHEYEL',
  STENON: 'STENON',
  TIMBAU: 'TIMBAU',
  TIMBRO: 'TIMBRO',
  TIMYEL: 'TIMYEL',
  KUNGRY: 'KUNGRY',
  ZINK: 'ZINK',
  ZINKFX: 'ZINKFX',
  ALU: 'ALU',
  LINBLA: 'LINBLA',
  KUNBLA: 'KUNBLA',
  SHEDOKA: 'SHEDOKA',
  LACRED: 'LACRED',
  LACYEL: 'LACYEL',
  DLACBLU: 'DLACBLU',
  DTIMBAU: 'DTIMBAU',
  DTIMYEL: 'DTIMYEL',
  DZINK: 'DZINK',
  DZINKFX: 'DZINKFX',
  DALU: 'DALU',
  DSHEALU: 'DSHEALU',
  DLINBLA: 'DLINBLA',
  DKUNGRY: 'DKUNGRY',
  DLACYEL: 'DLACYEL',
  SPRO: 'SPRO',
  SFAL: 'SFAL',
  STRI: 'STRI',
  SFRAME: 'SFRAME',
  SELEM: 'SELEM',
  SHEAD: 'SHEAD',
  SHEADBLU: 'SHEADBLU',
  SHEADBLUL: 'SHEADBLUL',
  SHEADGRY: 'SHEADGRY',
  TwoDFRONT: 'TwoDFRONT',
  TwoDSIDE: 'TwoDSIDE',
  TwoDBACK: 'TwoDBACK',
  TwoDLEFT: 'TwoDLEFT',
  TwoDRIGHT: 'TwoDRIGHT',
  TwoDOTHER: 'TwoDOTHER',
  TwoDTOP: 'TwoDTOP',
  ADJUSTABLECLAMPPOSITION: 'ADJUSTABLECLAMPPOSITION',
} as const;
